import { format } from "upath";

/**
 *
 *  Fetch and render customer store credit history.
 *
 */

function formatDateAU(d){
    let mydate = new Date(d);
    return mydate.getDate() + "/" + (mydate.getMonth() + 1) + "/" + mydate.getFullYear()
}

function formatDateUS(d){
    let mydate = new Date(d);
    return (mydate.getMonth() + 1) + "/" + mydate.getDate() + "/" +  mydate.getFullYear()
}


function loadStoreCreditHistory() {
    $('[data-store-credit-transactions]').each(function() {
        
        // console.log("load credit : ", this);

        const $container = $(this),
            customer_id = $container.attr('data-store-credit-transactions'),
            customer_signature = $container.attr('data-store-credit-customer-signature');

        $.getJSON(`/a/store-credit/customers/${customer_id}/transactions.json?sort=-created_at`, { customer_signature: customer_signature }, function(result) {
        $container.html(result.data.map((transaction) => {
            return `<tr>
                    <td>${ formatDateAU(transaction.attributes.created_at )}</td>
                    <td>${ formatDateAU(transaction.attributes.expires_at )}</td>
                    <td>${transaction.attributes.message}</td>
                    <td class="text-center">${transaction.attributes.status}</td>
                    <td class="text-right">${transaction.attributes.amount_human}</td>
                    <td class="text-right">${transaction.attributes.current_balance_human}</td>
                    </tr>`;
        }));
        });
    });
}

loadStoreCreditHistory();